import { Box, Divider, Typography } from "@mui/material";
import { useStyles } from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import { InformationsProps } from "../../types/InformationsTypes";
import { CpfMask, FormatMoneyDynamic } from "../../utils/masks";
import { useEffect, useState } from "react";

export function RequestedSummary({
  setOpenSummary,
  firstSegment,
  holderName,
  holderCpf,
  holderPhone,
  holderEmail,
  holderAddress,
  holderCep,
  dependents,
  plan,
  paymentType,
  paymentDate,
  total,
  value,
  planNameSelected,
  planSelected,
  linkType,
}: InformationsProps) {
  const classes = useStyles();
  const today = new Date();
  const day = today.getDate().toString().padStart(2, "0");

  const getDatePlus30Days = () => {
    const currentDate = new Date();
    const futureDate = new Date(currentDate);
    futureDate.setDate(currentDate.getDate() + 30);

    // Usando toLocaleDateString para garantir formato brasileiro consistente
    return futureDate.toLocaleDateString("pt-BR");
  };

  const [billDueDate, setBillDueDate] = useState(
    localStorage.getItem("selectedDaysBoleto") || ""
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const newValue = localStorage.getItem("selectedDaysBoleto") || "";
      if (newValue !== billDueDate) {
        setBillDueDate(newValue);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [billDueDate]);

  const isBlackFridayPromo = linkType === "1" && paymentType === "credit_card";
  const isAniversarioPromo = linkType === "2" && paymentType === "credit_card";
  const isPromoCreditCard = isBlackFridayPromo || isAniversarioPromo;

  const promoPriceLabel = isBlackFridayPromo ? "R$ 15,90" : "R$ 20,00";
  const promoPeriodLabel = isBlackFridayPromo
    ? "nos 3 primeiros meses"
    : "na primeira mensalidade";

  return (
    <Box className={classes.container}>
      <Box className={classes.header}>
        <Typography className={classes.title}>Resumo do pedido</Typography>
        <CloseIcon onClick={() => setOpenSummary(false)} />
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.containerInfoHolder}>
        <Box className={classes.containerRow}>
          <Typography className={classes.titleHolder}>Titular</Typography>
          <Box className={classes.containerIcon}></Box>
        </Box>
        <Typography className={classes.infoHolder}>
          {holderName || "Não informado"} (CPF:{" "}
          {CpfMask(holderCpf) || "Não informado"})
        </Typography>
        <Box
          className={classes.containerRow}
          style={{ justifyContent: "normal" }}
        >
          <Typography className={classes.infoHolder}>
            Telefone: {holderPhone || "Não informado"}
          </Typography>
          <Typography className={classes.infoHolder}>
            Email: {holderEmail || "Não informado"}
          </Typography>
        </Box>
        <Typography className={classes.infoHolder}>
          Endereço: {holderAddress || "Não informado"}
        </Typography>

        <Typography className={classes.infoHolder}>
          CEP: {holderCep || "Não informado"}
        </Typography>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.containerInfoHolder}>
        <Box className={classes.containerRow}>
          <Typography className={classes.titleHolder}>
            Informações do plano
          </Typography>
          <Box className={classes.containerIcon}></Box>
        </Box>
        {isPromoCreditCard ? (
          <Box>
            <Typography className={classes.infoHolder}>
              {planNameSelected ? `${planNameSelected} ` : "Não informado"}
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                className={classes.infoHolder}
                sx={{
                  textDecoration: "line-through",
                  color: "#999",
                  fontSize: "14px",
                }}
              >
                ({FormatMoneyDynamic(value ?? "29.90")})
              </Typography>
              <Typography
                className={classes.infoHolder}
                sx={{ color: "#d32f2f", fontWeight: "bold" }}
              >
                ({promoPriceLabel})
              </Typography>
              <Typography
                className={classes.infoHolder}
                sx={{ fontSize: "12px", color: "#666" }}
              >
                {promoPeriodLabel}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography className={classes.infoHolder}>
            {planNameSelected
              ? `${planNameSelected} (${FormatMoneyDynamic(value ?? "29.90")})`
              : "Não informado"}
          </Typography>
        )}
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.containerInfoHolder}>
        <Box className={classes.containerRow}>
          <Typography className={classes.titleHolder}>
            Forma de pagamento
          </Typography>
          <Box className={classes.containerIcon}></Box>
        </Box>
        <Typography className={classes.infoHolder}>
          Pagamento:{" "}
          {paymentType === "boleto"
            ? "Parcelado em 12x"
            : "Mensal (recorrente)"}
        </Typography>
        {paymentType === "boleto" && (
          <Typography className={classes.infoHolder}>
            Taxa de processamento:{" "}
            {paymentType === "boleto" ? planSelected.tax : "R$ 5,00"}
          </Typography>
        )}
        <Typography className={classes.infoHolder}>
          Tipo de pagamento:{" "}
          {paymentType === "credit_card"
            ? "Cartão de crédito"
            : paymentType === "boleto"
            ? "Boleto Bancário"
            : paymentType === "cpfl"
            ? "Pagamento CPFL"
            : paymentType === "pix_automatico"
            ? "Pix Automático"
            : "Não informado"}
        </Typography>

        <Typography className={classes.infoHolder}>
          {(firstSegment === "promocional" || firstSegment === "true" || (typeof firstSegment === "boolean" && firstSegment))
            ? `Data do primeiro lançamento: ${getDatePlus30Days()}`
            : `Data do lançamento: Mensal dia ${day}`}
        </Typography>
        {paymentType === "boleto" && (
          <Typography className={classes.infoHolder}>
            Data do vencimento: Mensal dia{" "}
            {billDueDate !== "" ? billDueDate : "5"}
          </Typography>
        )}
        {isPromoCreditCard && (
          <Typography
            className={classes.infoHolder}
            sx={{
              marginTop: "10px",
              padding: "10px",
              backgroundColor: "#fff3cd",
              borderRadius: "4px",
              fontSize: "13px",
              color: "#856404",
            }}
          >
            {isBlackFridayPromo ? (
              <>
                ⚠️ Promoção Black Friday: As 3 primeiras mensalidades serão de
                R$ 15,90. Após esse período, o valor retornará ao valor normal
                de {FormatMoneyDynamic(value ?? "29.90")}.
              </>
            ) : (
              <>
                ⚠️ Promoção de Aniversário Dr. Saúde: A primeira mensalidade
                será de R$ 20,00. Demais cobranças, o valor retornará ao valor
                normal de {FormatMoneyDynamic(value ?? "29.90")}.
              </>
            )}
          </Typography>
        )}
        {paymentType === "credit_card" && (
          <Typography className={classes.observation}>
            * Caso o cartão seja cancelado ou renovado, por favor entre em
            contato com a nossa equipe para atualização financeira, caso
            contrário seu plano será cancelado automaticamente
          </Typography>
        )}
      </Box>
      <Divider className={classes.divider} />
      <Box
        className={classes.containerRow}
        style={{ justifyContent: "space-between" }}
      >
        <Typography
          className={classes.titleHolder}
          style={{ fontSize: "20px" }}
        >
          Total:
        </Typography>
        {isPromoCreditCard ? (
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                className={classes.titleHolder}
                style={{
                  fontSize: "25px",
                  textDecoration: "line-through",
                  color: "#999",
                }}
              >
                {FormatMoneyDynamic(value ?? "0,00")}
              </Typography>
              <Typography
                className={classes.titleHolder}
                style={{ fontSize: "35px", color: "#d32f2f", fontWeight: "bold" }}
              >
                {promoPriceLabel}
              </Typography>
            </Box>
            <Typography
              style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}
            >
              ({promoPeriodLabel})
            </Typography>
          </Box>
        ) : (
          <Typography
            className={classes.titleHolder}
            style={{ fontSize: "35px" }}
          >
            {paymentType === "boleto"
              ? planSelected?.total_formatted
              : FormatMoneyDynamic(value ?? "0,00")}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
